import styled from 'styled-components';
import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = `
  font-size: ${px2rem(10)};
  line-height: ${px2rem(16)};
  text-transform: uppercase;
  width: 100%;
`;

export default buildStyledComponent(
  'ProgressPane',
  styled.div,
  styles,
);



// WEBPACK FOOTER //
// ./components/WizardControllerHeader/ProgressPane.js